import React, { Component } from 'react';
import './assets/styles/App.sass';
import Header from './components/Header'
import About from './components/About'
import Footer from './components/Footer'
import Converter from './components/Converter'
import MostUsed from './components/MostUsed';
import MainMenu from './components/MainMenu';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { magnitude: { name: 'Magnitude', systems: [] }, showAbout: false };
  }

  setMagnitude(magnitude) {
    this.setState({ magnitude: magnitude });
  }

  toggleAbout() {
    this.setState({ showAbout: !this.state.showAbout });
  }

  render() {
    return (
      <div className="App">
        <Header onAboutClick={this.toggleAbout.bind(this)} />
        <About status={this.state.showAbout} />

        <main>
          <MainMenu />
          <Converter magnitude={ this.state.magnitude }/>
          <MostUsed onIconClick={ this.setMagnitude.bind(this) }/>
        </main>

        <Footer />
      </div>
    );
  }
}

export default App;
